import article_1 from "../articles/article-1/article.vue";
import article_10 from "../articles/article-10/article.vue";
import article_11 from "../articles/article-11/article.vue";
import article_2 from "../articles/article-2/article.vue";
import article_3 from "../articles/article-3/article.vue";
import article_4 from "../articles/article-4/article.vue";
import article_5 from "../articles/article-5/article.vue";
import article_6 from "../articles/article-6/article.vue";
import article_7 from "../articles/article-7/article.vue";
import article_8 from "../articles/article-8/article.vue";
import article_9 from "../articles/article-9/article.vue";


const ARTICLE_URLS = 
{
"article_1":"/articles/article-1.html",
"article_10":"/articles/article-10.html",
"article_11":"/articles/article-11.html",
"article_2":"/articles/article-2.html",
"article_3":"/articles/article-3.html",
"article_4":"/articles/article-4.html",
"article_5":"/articles/article-5.html",
"article_6":"/articles/article-6.html",
"article_7":"/articles/article-7.html",
"article_8":"/articles/article-8.html",
"article_9":"/articles/article-9.html"
};
  
const ARTICLES = 
[
{...(article_1.header),name:"article_1",url:ARTICLE_URLS["article_1"]},
{...(article_10.header),name:"article_10",url:ARTICLE_URLS["article_10"]},
{...(article_11.header),name:"article_11",url:ARTICLE_URLS["article_11"]},
{...(article_2.header),name:"article_2",url:ARTICLE_URLS["article_2"]},
{...(article_3.header),name:"article_3",url:ARTICLE_URLS["article_3"]},
{...(article_4.header),name:"article_4",url:ARTICLE_URLS["article_4"]},
{...(article_5.header),name:"article_5",url:ARTICLE_URLS["article_5"]},
{...(article_6.header),name:"article_6",url:ARTICLE_URLS["article_6"]},
{...(article_7.header),name:"article_7",url:ARTICLE_URLS["article_7"]},
{...(article_8.header),name:"article_8",url:ARTICLE_URLS["article_8"]},
{...(article_9.header),name:"article_9",url:ARTICLE_URLS["article_9"]}
];

const TOP =  ARTICLES.find((art) => art.name == "article_1");


ARTICLES.sort((a, b) => {
    if (a.formattedTime < b.formattedTime) {
      return 1;
    }
    if (a.formattedTime == b.formattedTime) {
      return 0;
    }
    if (a.formattedTime > b.formattedTime) {
      return -1;
    }
});
  

const articleContext = {
    top: TOP,
    articleList: ARTICLES,
};

export { articleContext };
